module.exports = __webpack_public_path__ + "img/top.9fdb01e4.svg";